import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mobileNumberFormat',
  standalone: true,
})
export class MobileNumberFormatPipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): string {
    if (!value) {
      return '';
    }
    const phoneStr = value.toString();
    if (phoneStr.length !== 10) {
      return phoneStr; // Return as is if not exactly 10 digits
    }
    return `+91 ${phoneStr.slice(0, 5)} ${phoneStr.slice(5)}`;
  }
}
